import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaBookOpen } from 'react-icons/fa';
// Then use <FaBookOpen /> Coaching History
import { FaClipboardList } from 'react-icons/fa';

import {
  FaHome,
  FaUserPlus,
  FaMoneyBill,
  FaListUl,
  FaWallet,
  FaCertificate,
  FaChalkboardTeacher,
  FaUser,
  FaSignOutAlt,
  FaUniversity,
  FaHistory,
  FaExchangeAlt
} from 'react-icons/fa';
import '../styles/Dashboard.css';

const Dashboard = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (window.confirm("Are you sure you want to logout?")) {
      try {
        await axios.get(
          "https://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/logout.php",
          { withCredentials: true }
        );
        localStorage.removeItem('userEmail');
        navigate('/login');
        window.location.reload();
      } catch (error) {
        console.error("Logout failed:", error);
        alert("Error logging out. Please try again.");
      }
    }
  };

  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <h2 className="sidebar-header">🎓 Oxford Convent</h2>
        <nav className="sidebar-nav">
          <ul>
            <li><Link to="/home"><FaHome /> Home</Link></li>
            <li><Link to="/add-new-student"><FaUserPlus /> Add Student</Link></li>
            <li><Link to="/fee-payment"><FaMoneyBill /> Fee Payment</Link></li>
            <li><Link to="/student-payment-list"><FaListUl /> Payment List</Link></li>
            <li><Link to="/miscellaneous-expenses"><FaWallet /> Expenses</Link></li>
            <li><Link to="/certificates"><FaCertificate /> Certificates</Link></li>
            <li><Link to="/coaching"><FaChalkboardTeacher /> Coaching</Link></li>
            <li><Link to="/coaching-history"><FaHistory /> Coaching History</Link></li>
              <li><Link to="/coaching-fee-summary"><FaBookOpen /> Coaching Summary</Link></li> 
            <li><Link to="/bank-records"><FaUniversity /> Bank Records</Link></li>
            <li><Link to="/collection-history"><FaListUl /> Collection History</Link></li>
            <li><Link to="/records"><FaWallet /> Bank/Cash Records</Link></li>
            <li><Link to="/oldfeesstudent"><FaHistory /> Old Fees Student</Link></li>
            <li><Link to="/meeting-report"><FaClipboardList /> Meeting Report</Link></li>
            <li><Link to="/transaction-history"><FaExchangeAlt /> Transaction History</Link></li>
            <li><Link to="/user-profile"><FaUser /> Profile</Link></li>
          </ul>
        </nav>

        <div className="logout-section">
          <button className="logout-button" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </aside>

      <main className="content">
        {children}
      </main>
    </div>
  );
};

export default Dashboard;
